module.exports = __webpack_public_path__ + "static/media/directory-smart.2c8780d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/directory-smart.svg
// module id = 1630
// module chunks = 2